import React, { Fragment, useContext, useEffect, useState } from "react";

import { LoadingContext, MainContext } from "../Context";
import { PostListType } from "../Structures/Types/post";
import { TransactionGetBlog } from "../Services/Transactions";

import { formatDate, formatText } from "../Utils";
import { Link } from "react-router-dom";
import { PageHeader } from "../Components/Common";
import { Empty, Tag } from "../Components/Base";
import { TagType } from "../Structures";

const Blog = () => {
  const { setting } = useContext(MainContext);
  const { loading, setLoading } = useContext(LoadingContext);

  // ==============================================================================

  const [posts, setPosts] = useState<PostListType[]>([]);

  // ==============================================================================

  useEffect(() => {
    setLoading(true);
    TransactionGetBlog()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          setPosts(res.data || []);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  // ==============================================================================

  return (
    <Fragment>
      <PageHeader src={setting.blog_banner} title="اخبار" />
      <Empty
        data={posts}
        isLoading={loading}
        description="درحال حاضر خبری وجود ندارد"
      >
        <div className="container">
          <div className="row">
            <div className="col-12 mb-4">
              <div className="row g-4">
                {posts.map((post: PostListType) => (
                  <div className="col-sm-6 col-lg-4" key={post.id}>
                    <Link
                      to={`/blog/${post.id}/`}
                      className="card post-blog-cart"
                    >
                      <div
                        style={{ height: 200 }}
                        className="w-100 overflow-hidden position-relative"
                      >
                        <img
                          className="card-img rounded-bottom-0 w-100 h-100 object-fit-cover overflow-hidden position-relative"
                          src={post.poster}
                          alt={post.title}
                        />
                        <div className="card-img-overlay d-flex align-items-start flex-column p-3">
                          <div className="w-100 mt-auto">
                            {post.categories.map((tag: TagType) => (
                              <Tag key={tag.id} tag={tag} />
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="card-body px-3 pt-3">
                        <div className="card-title">
                          <h5 className="btn-link fw-bold text-reset truncate">
                            {post.title}
                          </h5>
                        </div>
                        <p className="card-text text-justify">
                          {formatText(post.description, 100)}
                        </p>

                        <ul className="nav nav-divider align-items-center d-none d-sm-inline-block">
                          <li className="nav-item">
                            <i className="fa fa-calendar me-2 small fw-bold"></i>
                            {formatDate(post.timeStamp)}
                          </li>
                        </ul>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Empty>
    </Fragment>
  );
};

export default Blog;
